import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  async getData(params) {
    try {
      const response = await axios.get('uni/student_file', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return {
            records: data.data.records,
            total: data.data.total,
        }
      }
    } catch (e) {
      handleCatch(e)
    }
    return []
  },
  async deleteFile(id) {
    try {
      const response = await axios.delete(`uni/student_file/${id}`)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async uploadStudentFile(params) {
    try {
      const response = await axios.post('uni/student_file/uploadFile', params)
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
      return []
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
    async saveFile(body) {
        try {
            const response = await axios.post('uni/student_file', body)
            const { data } = response
            return {
                isSuccessful: data.code === ApiCode.SUCCESS,
                message: data.message,
            }
        } catch (e) {
            handleCatch(e)
        }
        return null
    },
    async updateFile(params) {
        try {
            const response = await axios.put(`uni/student_file/${params.id}`, params)
            const { data } = response
            return {
                isSuccessful: data.code === ApiCode.SUCCESS,
                message: data.message,
            }
        } catch (e) {
            handleCatch(e)
        }
        return null
    },

}
